import React, { useEffect, useState } from "react";

/* -------- packages -------- */
import {  Modal, ModalHeader, ModalBody, Container, Row, Col, Spinner } from "reactstrap";
import { useTranslation } from "react-i18next";
import { toast, ToastContainer } from "react-toastify";
import {
  Input
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
/* -------- ------- -------- */

/* -------- components -------- */
import { avatarImages } from "../../../utils/items";
/* -------- ------- -------- */

/* -------- intern functions -------- */
import { fetchUserRequest } from "../../../store/actions";
/* -------- ------- -------- */

export default function ProfileImageModal ({isModalOpen, setModalOpen, editFunction}) { // isModalOpen (BOOLEAN), setModalOpen (useState Function(true/false))
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const parameters = useSelector(state => state.Parameters);

  const user = useSelector(state => state.Login.user);

  const userPref = user.prefs;


  useEffect(() => {
    dispatch(fetchUserRequest(user.id));
  }, [dispatch]);    

  return (
    <Modal isOpen={isModalOpen} toggle={() => setModalOpen(false)} centered={true} size={'xl'} scrollable={true} className="profileImageModal">
      <ModalHeader toggle={() => setModalOpen(false)}>{`${t('newProfileImage')}`}</ModalHeader>
      <ModalBody>
        <Container>
          <Row className="d-flex justify-content-center w-100 m-0 p-0">
            {avatarImages.map((image, index) => (
              <Col key={index} xl={2} l={3} md={4} s={2} className={"avatarContainer d-flex justify-content-center p-2 m-0"}>
                <div className={"avatarImage w-75 p-3" + (user && userPref?.profileImage == image.id ? " active" : " ")} onClick={() => editFunction(image.id)}>
                  { (image.path) ?
                    <img src={image.path} alt={image.lib} className="avatarPreview" />
                    :
                    <Spinner />
                  }
                </div>
              </Col>
            ))}
          </Row>
        </Container>
        <ToastContainer />
      </ModalBody>
    </Modal>
  )

}